import React, {
    createContext,
    Dispatch,
    ReactNode,
    SetStateAction,
    useContext,
    useMemo,
    useState
  } from "react";

import { useLocalStorage } from "../Authprovider/useLocalStorage"
import { GuestsObject } from "components/HeroSearchForm2Mobile/GuestsInput";
import { DateRage } from "components/HeroSearchForm2/StaySearchForm";



  export interface SearchContextType {
    // We defined the user type in `index.d.ts`, but it's
    // a simple object with email, name and password.
    guest?:  GuestsObject;
    dates?: DateRage;
    location?: string;
  }
  
  const SearchContext = createContext({
    state: {} as Partial<SearchContextType>,
    setState: {} as Dispatch<SetStateAction<Partial<SearchContextType>>>,
  });
  
  // Export the provider as we need to wrap the entire app with it
  export function SearchProvider({
    children,
    value = {} as SearchContextType
  }: {
    children: ReactNode;
    value?: Partial<SearchContextType>;
  }): JSX.Element {
    
    const [state, setState] = useState(value);
   
    const memoedValue = useMemo(
      () => ({
        state,
        setState,
      }),
      [state, setState]
    );
  
    // We only want to render the underlying app after we
    // assert for the presence of a current user.
    return (
      <SearchContext.Provider value={memoedValue}>
        { children}
      </SearchContext.Provider>
    );
  }
  
  // Let's only export the `useAuth` hook instead of the context.
  // We only want to use the hook directly and never the context component.
  export default function useSearch() {
    return useContext(SearchContext);
  }